import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs,validationSchema } from '@/entities/GeneralSettings/GeneralSettingsFormInputs'

const GeneralSettings = {
	Plural: 'GeneralSettings',
	Single: 'GeneralSettings',
	Inputs: Inputs,	
	FormWithImage: true,
	Relationships: [
		{
			name: 'hotGames',
			endpoint: Endpoints.GAMES_FOR_FILTERS_NEW,
			dataMapping: (response) => {

				response.forEach(element => {
					element['name'] = element.homeTeamName + " - " + element.awayTeamName + " ("+element.gameDate+")"
				});

				return response;
			},
			mapping: (response) => {
				return response;
			},
		},
		{
			name: 'games',
			endpoint: Endpoints.GAMES_FOR_FILTERS_NEW,
			dataMapping: (response) => {

				response.forEach(element => {
					element['name'] = element.homeTeamName + " - " + element.awayTeamName + " ("+element.gameDate+")"
				});

				return response;
			},
			mapping: (response) => {
				return response;
			},
		}
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		//router.push(`/leagues/edit/${id}`)
	}
};

export default GeneralSettings;
